import { GearItemCard } from '../../../../../Cards/GearItemCard/GearItemCard';
import type { CatchGearItem } from '../../../../types/CatchGearItem';

interface CatchGearCardsProps {
  catchGear: CatchGearItem[];
}

export const CatchGearCards = ({ catchGear }: CatchGearCardsProps) => {
  return (
    <div>
      {catchGear.map(({ product: { _id, brand, image, displayName } }) => (
        <GearItemCard
          key={`catch-gear-${_id}`}
          brand={brand.name}
          image={image}
          name={displayName || ''}
        />
      ))}
    </div>
  );
};
